export enum TipoDataRecebimentoPadraoEnum {
    Pagamento = 1,
    Credito = 2
}
